export var AMSRoutes = {
    "/ams/:job_id?assessmentCId&application_id&interview_status?showOBDocumentsModal": {
        "enableUTM": true,
        "showGlobalSearch": true,
        "name": "appLayout.harriSH.AMS",
        "type": "frontend-backend",
        "data": [
            {"type": "static-data", "id": "menus"}
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["rejection_templates", "pre_hire", "ams_columns_settings"]
        },
        "reloadOnSearch": false,
        "component": "amsPage",
        "loginRequired": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./ams.module.js");
                }
            },{
                type: 'chunk', loader: function () {
                    return import("../../hmodules/pos-integration/pos-integration.module.js");
                }
            },
            {
                type: 'chunk', loader: () => {
                    return import("../../hmodules/right-to-work/right-to-work.module.js");
                }
            },
            {
                type: 'chunk', loader: () => {
                    return import("../../hmodules/trust-id/trust-id.module.js");
                }
            },
            {
                type: 'chunk', loader: () => {
                    return import("../../hmodules/onboarding-automation/onboarding-automation.module.js");
                }
            },
            {
                type: 'chunk', loader: function () {
                    return import("../../hmodules/pre-hire/pre-hire.module.js");
                }
            }
        ]
    },
    "/application/:bucket_id/:app_id?show_reviewer?show_profile_matching": {
        "name": "appLayout.harriSH.AMS.applicants",
        "showGlobalSearch": true,
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["rejection_templates"]
        },
        "dynamic": true,
        reloadOnSearch: false,
        views: {
            "speedyscreen": {
                "controller": "amsSSController",
                "templateUrl": "../modules/ams/views/ams-ss.html"
            }
        },
        "onExit": function () {
            $('#interview-modal .modal').modal('hide');

            /* close Profile FancyBox if it's displayed */
            $.fancybox.close();
        },
        "loginRequired": true,
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/talent-pool/talent-pool.module.js");
                }
            },
            {path: "d3", type: "library", "name": "d3"},
            {path: "c3", type: "library", "name": "c3"}
        ]
    },

    "/media/:img_id": {
        "name": "appLayout.harriSH.AMS.applicants.media_viewer",
        "showGlobalSearch": false,
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["rejection_templates"]
        },
        views: {
            "media-viewer": {
                templateUrl: "../modules/media_viewer/views/viewer.html",
            }
        }
    }
};
